import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

let headers = ''

function headersSet() {
  const headersQ = window.localStorage.getItem('Headers')
  headers = JSON.parse(headersQ)
}

// const headers = {
//   token: '9hcSox+C8Tw3q2/ykBzEA8m8g1BpBAUzyCWGyqDPnOn2G5Uj9ZTaq7gIyaX5zD+0',
//   userID: '8s+T84Du8ZQdNuCFnstn9Q==',
//   databaseID: '8s+T84Du8ZQdNuCFnstn9Q==' 
// }

// export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
//   const response = await axios.get('https://api.zasway.com:8443/api/users/list/all-data')
//   const response = await axios.get('https://api.zasway.com:8443/api/users/list/all-data')
//   return response.data
// })

// export const getData = createAsyncThunk('appUsers/getData', async params => {
//   const response = await axios.get('https://api.zasway.com:8443/api/users/list/data', params)
//   const response = await axios.get('https://api.zasway.com:8443/api/users/list/data', params)
//   return {
//     params,
//     data: response.data.users,
//     totalPages: response.data.total
//   }
// })

// export const getUser = createAsyncThunk('appUsers/getUser', async id => {
//   const response = await axios.get('https://api.zasway.com:8443/api/users/user', { id })
//   return response.data.user
// })

export const getAllData = createAsyncThunk('appPassenger/GetTableSummary', async (GetPassenger) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummary', GetPassenger, { headers }, { mode: 'cors' })
  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response.data
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, {mode:'cors'})
  return response.data 
})

export const addPassenger = createAsyncThunk('appPassenger/Create', async (Passenger) => {
  headersSet()
   
  const response = await axios.post('https://api.zasway.com:8443/Passenger/Create', Passenger, { headers }, { mode: 'cors' })
   
  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
  // , { dispatch, getState }
  // await dispatch(getData(getState().users.params))
  // await dispatch(getAllData())
})

export const EditPassenger = createAsyncThunk('appPassenger/Update', async (Passenger) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Passenger/Update', Passenger, { headers }, { mode: 'cors' })
  // , { dispatch, getState }
  // await dispatch(getData(getState().users.params))
  // await dispatch(getAllData())
  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const validatePassengerMobile = createAsyncThunk('appPassenger/validatePassengerMobile', async (GetPassenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetValidNewPassenger', GetPassenger, { mode: 'cors' })
  return response.data
})
export const validatePassengerMobileEdit = createAsyncThunk('appPassenger/validatePassengerMobileEdit', async (GetPassenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetValidNewPassengerEdit', GetPassenger, { mode: 'cors' })
  return response.data
})

export const getClientList = createAsyncThunk('appPassenger/getClientList', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetClientList', params, {mode: 'cors'})
  return response.data
})

export const getPassengerSurnameList = createAsyncThunk('appPassenger/GetPassengerSurNameList', async () => {
  
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerSurNameList')
  
  return response.data
})

export const getPassengerStats = createAsyncThunk('appPassenger/GetPassengerStatistics', async (GetPassenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerStatistics', GetPassenger, { mode: 'cors' })
  return response.data
})

export const getPassengerBookingCount = createAsyncThunk('Passenger/GetPassengerBookingCount', async (GetPassenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerBookingCount', GetPassenger, { mode: 'cors' })
  return response.data
})

export const getPassengerImage = createAsyncThunk('appDriver/GetPassengerImage', async (Passenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetPassengerImage', Passenger, { mode: 'cors' })
  return response.data
})

export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/UploadImagePassenger', formData, { mode: 'cors' })
  return response
})

export const getUser = createAsyncThunk('appUsers/getUser', async () => {
  const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', data)
  return response.data
})

// export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
//    
//   await axios.post('https://api.zasway.com:8443/User/CreateUser', user, {mode:'cors'})
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return user
// })


// export const addStaff = createAsyncThunk('Passenger/Create', async (Passenger) => {
//    
//   const response = await axios.post('https://api.zasway.com:8443/Passenger/Create', Passenger, {mode:'cors'})
//   // , { dispatch, getState }
//   // await dispatch(getData(getState().users.params))
//   // await dispatch(getAllData())
//   return response
// })
// export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
//   await axios.post('https://api.zasway.com:8443/apps/users/add-user', user)
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return user
// })


// export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
//   await axios.delete('/apps/users/delete', { id })
//   await dispatch(getData(getState().users.params))
//   await dispatch(getAllData())
//   return id
// })

// export const appUsersSlice = createSlice({
//   name: 'Passenger',
//   initialState: {
//     data: [],
//     total: 1,
//     params: {},
//     allData: [],
//     selectedUser: null
//   },
//   reducers: {},
//   extraReducers: builder => {
//     builder
//       .addCase(getAllData.fulfilled, (state, action) => {
//          
//         state.allData = action.payload.data
//         state.data = action.payload.data
//       })
//       .addCase(getData.fulfilled, (state, action) => {
//          
//         state.data = action.payload.data
//         state.params = action.payload.params
//         state.total = action.payload.totalPages
//       })
//       .addCase(getUser.fulfilled, (state, action) => {
//         state.selectedUser = action.payload
//       })
//   }
// })


//-----------------------------------------------------------------------------

// export const getData = createAsyncThunk('appPassenger/getData', async params => {
//    
//   const response = await axios.get('/apps/invoice/invoices', params)
//    
//   return {
//     params,
//     data: '',
//     allData: response.data.allData,
//     totalPages: response.data.total
//   }
// })

export const getData = createAsyncThunk('appPassenger/getData', async (params) => {
  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummary', params, { headers }, { mode: 'cors' })
  if (response.data.code === undefined) {
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const getPassenger = createAsyncThunk('appPassenger/getPassenger', async (params) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummary', params, { mode: 'cors' })
  return {
    params,
    data: response.data.data,
    allData: response.data.allData,
    totalPages: response.data.total
  }
})

export const deletePassenger = createAsyncThunk('appPassenger/Delete', async (id, { dispatch, getState }) => {

  headersSet()
  const response = await axios.post('https://api.zasway.com:8443/Passenger/Delete', id, { mode: 'cors' })
  await dispatch(getData(getState().passenger.params))

  if (response.data.code === undefined || response.data.code === 200) {
    return {
      data: response
    }
  } else {
    return {
      data: response.data.code
    }
  }
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.post('https://api.zasway.com:8443/User/DeleteUser', "2", { mode: 'cors' })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const GetTopPassenger = createAsyncThunk('Passenger/GetTopPassenger', async (GetPassenger) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTopPassenger', GetPassenger, { mode: 'cors' })
  return response.data
})

export const deleteInvoice = createAsyncThunk('appPassenger/deleteInvoice', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/invoice/delete', { id })
  await dispatch(getData(getState().passenger.params))
  return id
})

export const CloseModel = createAsyncThunk('/appPassenger/CloseModel', (IsClosed) => {
  return { data: IsClosed }
})

export const ResetCloseModelPassenger = createAsyncThunk('/commonLocation/ResetCloseModelPassenger', () => {
  return {
    data: false
  }
})

export const setRecentlyAddedPassengerID = createAsyncThunk('/appPassenger/setRecentlyAddedPassengerID', (RecentPassengerID) => {
 
  return {
    data: RecentPassengerID
  }
})

export const setRecentlyAddedPassengerClientID = createAsyncThunk('/appPassenger/setRecentlyAddedPassengerClientID', (RecentPassengerClientID) => {
 
  return {
    data: RecentPassengerClientID
  }
})

export const setRecentlyAddedPassengerClientName = createAsyncThunk('/appPassenger/setRecentlyAddedPassengerClientName', (RecentPassengerClientName) => {
 
  return {
    data: RecentPassengerClientName
  }
})

export const setRecentlyAddedPassengerName = createAsyncThunk('/appPassenger/setRecentlyAddedPassengerName', (RecentPassengerName) => {
 
  return {
    data: RecentPassengerName
  }
})

export const setPassengerNull = createAsyncThunk('/appPassenger/setPassengerNull', () => {
  return true
})

export const getPassengerWeekDays = createAsyncThunk('appPassenger/getPassengerWeekDays', async (GetWDDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerWeekDays', GetWDDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const getPassengerBookingTrends = createAsyncThunk('appPassenger/getPassengerBookingTrends', async (GetBTDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Passenger/GetPassengerBookingTrends', GetBTDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const getAllBookingTrends = createAsyncThunk('appPassenger/getAllBookingTrends', async (GetBTDetails) => {
  const response = await axios.post('https://api.zasway.com:8443/Common/GetAllBookingTrends', GetBTDetails, { mode: 'cors' })
  return {
    data: response.data
  }
})

export const appPassengerSlice = createSlice({
  name: 'appPassenger',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    IsClosed: false,
    recentPassengerID: 0,
    PassengerWeekDaysData: [],
    PassengerBookingTrends: [],
    AllBookingTrends: [],
    Loader: false
  },
  reducers: {},
  extraReducers: builder => {
    builder

    .addCase(setPassengerNull.pending, (state) => {
      state.Loader = true
    })
      .addCase(setPassengerNull.fulfilled, (state) => {
        state.Loader = false
        state.recentPassengerID = 0
      })

      .addCase(setRecentlyAddedPassengerClientID.fulfilled, (state, action) => {

        state.recentPassengerClientID = action.payload.data
      })

      .addCase(setRecentlyAddedPassengerClientName.fulfilled, (state, action) => {

        state.recentPassengerClientName = action.payload.data
      })

      .addCase(setRecentlyAddedPassengerName.fulfilled, (state, action) => {

        state.recentPassengerName = action.payload.data
      })

      .addCase(getPassengerWeekDays.fulfilled, (state, action) => {
        state.PassengerWeekDaysData = action.payload.data
      })

      .addCase(getPassengerBookingTrends.fulfilled, (state, action) => {
        state.PassengerBookingTrends = action.payload.data
      })

      .addCase(getAllBookingTrends.fulfilled, (state, action) => {
        state.AllBookingTrends = action.payload.data
      })

      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
        state.params = action.payload.params
      })

      .addCase(getPassenger.fulfilled, (state, action) => {
        state.selectedUser = action.payload.allData[0]
      })

      .addCase(CloseModel.fulfilled, (state, action) => {
        state.IsClosed = action.payload.data
      })
   
      .addCase(setRecentlyAddedPassengerID.fulfilled, (state, action) => {

        state.recentPassengerID = action.payload.data
      })

      .addCase(ResetCloseModelPassenger.pending, (state) => {
        state.Loader = true
      })
      .addCase(ResetCloseModelPassenger.fulfilled, (state, action) => {
        state.Loader = false
        state.IsClosed = action.payload.data
      })
     
  }
})

export default appPassengerSlice.reducer